<template>
  <div class="page-all">
    <Header
      :variant="$route.meta.headerVariant || 'default'"
      :isHide="$route.meta.headerIsHide === true"
      ref="headerComponent"
    />
    <KeepAlive max="5">
      <router-view ref="routerView" />
    </KeepAlive>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
// vuex
import { mapMutations } from "vuex";
export default {
  name: "showBase",
  components: {},
  data() {
    return {};
  },
  computed: {},

  created() {},
  methods: {
    // vuex
    ...mapMutations(["changeState"]),
    
    // 提供给子组件调用的方法，支持传递 action 参数
    openLoginBox(action = 'login') {
      this.$refs.headerComponent.openPopBox(action);
    }
  },
  
  // 将方法暴露给子组件
  provide() {
    const that = this;
    return {
      openLoginBox(action = 'login') {
        return that.openLoginBox(action);
      }
    }
  }
};
</script>

<style lang="less" scoped></style>